import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styles from './Map.module.scss';
import dynamic from 'next/dynamic';
import i18n from '../../i18n';
import classNames from 'classnames';
import { getCookie, getApprovedCookieTargets } from '../../utils/cookie';
import { GlobalPropsContext } from '../../utils/globalProps';
const CookieBlocker = dynamic(() => import('../CookieBlocker'));

const Map = ({ lang, coords, address, q, modifier }) => {
    const globalProps = useContext(GlobalPropsContext);
    const { activateCookieScript } = globalProps;

    q = coords.length > 0 ? `${coords[1]},${coords[0]}` : q;

    const classes = classNames(styles['Map'], {
        [styles[`Map--${modifier}`]]: !!modifier,
    });

    const handleCookieSelector = () => {
        if (activateCookieScript) {
            const targets = getApprovedCookieTargets();
            const googleMapsApproved =
                targets.accept.includes('targeting') &&
                targets.accept.includes('performance');

            return googleMapsApproved;
        } else {
            const checkHasAcceptedCookies = getCookie('enableTracking');
            return checkHasAcceptedCookies;
        }
    };
    const url = `https://maps.google.com/maps?q=${q}&hl=${lang}&zoom=5&output=embed`;

    return (
        <div className={classes}>
            <div className={styles['Map__Content']}>
                {handleCookieSelector() ? (
                    <iframe
                        id="map"
                        title={address || i18n.t('map.defaultIfNoAddress')}
                        className={styles['Map__IframeMap']}
                        frameBorder={0}
                        src={url}
                    ></iframe>
                ) : (
                    <CookieBlocker type="Map" url={url} />
                )}
            </div>
        </div>
    );
};

Map.propTypes = {
    lang: PropTypes.string,
    q: PropTypes.string,
    modifier: PropTypes.string,
    coords: PropTypes.array,
    address: PropTypes.string,
};

Map.defaultProps = {
    lang: '',
    q: '',
    modifier: '',
    coords: [],
    address: '',
};

export default Map;
